/**
 * Whether the user menu offers "Client portal".
 *
 * Staff and clients in a company are known from the RBAC context, with no request.
 * Anyone else (for example a client whose only access is a booking grant) asks the
 * server once. A failed or negative check hides the item.
 */
import { useEffect, useState } from 'react';
import { getPortalAccess } from '@/lib/portalApi';
import { canOpenClientPortal } from '@/components/layout/clientPortalAccess';

export function useClientPortalAccess({ isInternal, companies, signedIn }: {
  isInternal: boolean;
  companies: ReadonlyArray<unknown> | null | undefined;
  signedIn: boolean;
}): boolean {
  const knownLocally = canOpenClientPortal({ isInternal, companies });
  const needsCheck = signedIn && !knownLocally;
  const [serverSays, setServerSays] = useState(false);

  useEffect(() => {
    if (!needsCheck) return undefined;
    let cancelled = false;
    getPortalAccess().then((ok) => { if (!cancelled) setServerSays(ok); });
    return () => { cancelled = true; };
  }, [needsCheck]);

  if (!signedIn) return false;
  return knownLocally || serverSays;
}
